import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import global from "./global/";
import resume from "./resume/";
import positionList from "./positionList/";
import aboutCity from "./aboutCity/";
import thirdResume from "./thirdResume/";
import sessionInfo from "./sessionInfo/";
import schoolAmbassador from "./schoolAmbassador/";
import app from "./app/";
const store = new Vuex.Store({
  modules: {
    app,
    global,
    resume,
    positionList,
    aboutCity,
    thirdResume,
    sessionInfo,
    schoolAmbassador
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js